import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputComponent } from "@components/input/input.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { TextmultilineComponent } from "@components/textmultiline/textmultiline.component";
import { Viol3statusIndicatorComponent } from "@components/viol3status-indicator/viol3status-indicator.component";
import { Anskaffningsformer } from "~app/common/models/constants";
import { ArbetsorderViol3MakuleraButtonComponent } from "../../../arbetsorder-viol3/arbetsorder-viol3-makulera-button/arbetsorder-viol3-makulera-button.component";
import { ArbetsorderInfoSummaryComponent } from "../arbetsorder-info-summary/arbetsorder-info-summary.component";

@Component({
    selector: "rask-arbetsorder-info-summary-extern",
    templateUrl: "./arbetsorder-info-summary-extern.component.html",
    styleUrls: ["./arbetsorder-info-summary-extern.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        FormsModule,
        TextmultilineComponent,
        SelectorComponent,
        Viol3statusIndicatorComponent,
        ArbetsorderViol3MakuleraButtonComponent
    ]
})
export class ArbetsorderInfoSummaryExternComponent extends ArbetsorderInfoSummaryComponent {

    constructor() {
        super();
    }

    isImport() {
        return this.arbetsorder.anskaffningsform === Anskaffningsformer.Import;
    }

    isCkArbetsorder() {
        return this.arbetsorder.anskaffningsform === Anskaffningsformer.CentralaKop;
    }

    isEgenTerminal() {
        return this.arbetsorder.anskaffningsform === Anskaffningsformer.EgenTerminal;
    }
}
